<template>
  <div class="kv_item_cla">
    <label>{{ label }}：</label>
    <span class="value-cla">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ZkKvItem',
  data () {
    return {}
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  mounted () { },
  methods: {}
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.kv_item_cla {
  padding: 5px;
  width: 50%;
  min-height: 35px;
  box-sizing: border-box;
  float: left;
  display: flex;
  label {
    display: inline-block;
    width: 160px;
    padding-right: 20px;
    text-align: right;
    white-space: nowrap;
    box-sizing: border-box;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
  }
  .value-cla {
    color: @fontColor3;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/kvItem/src/main.vue